
import cloneDeep from 'lodash/cloneDeep';
import { emptyObj, getRequestData } from '@/utils';
import {
  qryDIDInfoBsnl,
  manageSubsDIDBsnl,
} from '@/pages/ManageExtension/services/manageExtension';

export default {
  namespace: 'manageExtension',
  state: {
    step: 0, // 分机号码业务流程的步骤
    searchCustInfo: {}, // 从搜索页面同步过来的用户信息
    serviceType: {}, // 从搜索页面同步过来的服务类型
    subServiceType: {}, // 从搜索页面同步过来的子服务类型
    didList: [], // 订户下的分机号码列表
    addDIDNumber: {}, // 储存添加DIDTab数据
    deleteDIDNumber: {}, // 储存删除DIDTab数据
  },
  effects: {
    *qryDIDInfoBsnl({ payload }, { call, put }) {
      const response = yield call(qryDIDInfoBsnl, payload);
      const { didDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: { didList: didDtoList },
      });
    },
    *manageSubsDIDBsnl({ payload }, { call }) {
      const response = yield call(manageSubsDIDBsnl, payload);
      return getRequestData(response);
    },
  },

  reducers: {
    tabsSave(state, { payload, activeTabsKey }) {
      const tabState = { ...state[activeTabsKey], ...payload };
      state[activeTabsKey] = cloneDeep(tabState);
      return {
        ...state,
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear(state) {
      return emptyObj(state);
    },
  },
};
